module.exports = __webpack_public_path__ + "img/98ne.3f014154.svg";